import { render } from "./DashboardCardDropdown.vue?vue&type=template&id=bdf12cb4"
import script from "./DashboardCardDropdown.vue?vue&type=script&lang=js"
export * from "./DashboardCardDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__